import { Grid, SearchTextField } from "designSystem/index";
import React from "react";

export default () => (
	<Grid container spacing={5}>
		<Grid
			container
			item
			spacing={8}
			xs={12}
		>
			<Grid item>
				<SearchTextField
					label="Empty search field"
					placeholder="Search"
				/>
			</Grid>
			<Grid item>
				<SearchTextField
					disabled
					label="Disabled Search field"
					placeholder="Search"
				/>
			</Grid>
			<Grid item>
				<SearchTextField
					defaultValue="Input"
					label="Search field"
					placeholder="Search"
				/>
			</Grid>
		</Grid>
	</Grid>
);

